module.exports = __webpack_public_path__ + "static/img/school-16.61753fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-16.png
// module id = q3gn
// module chunks = 1